import { styled } from "../../../../styles";

/** Wrapper matching the vertical rhythm of ModalForm fields. */
export const UploadFieldContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  fontFamily: "$openSans",
});

export const UploadLabel = styled("label", {
  fontSize: "13px",
  fontWeight: "500",
  color: "$gray-80",
});

export const UploadDropArea = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  padding: "12px",
  border: "1px dashed $gray-40",
  borderRadius: "6px",
  backgroundColor: "$white",
  transition: "border-color 0.15s ease, background-color 0.15s ease",

  variants: {
    state: {
      idle: {},
      dragging: {
        borderColor: "$primary",
        backgroundColor: "$primary-20",
      },
      invalid: {
        borderColor: "$error-dark",
      },
      disabled: {
        backgroundColor: "$gray-20",
        cursor: "not-allowed",
      },
    },
  },

  defaultVariants: {
    state: "idle",
  },
});

export const UploadFileName = styled("span", {
  flex: 1,
  fontSize: "13px",
  color: "$charcoal",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  variants: {
    empty: {
      true: {
        color: "$gray-60",
      },
    },
  },
});

export const UploadActions = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexShrink: 0,
});

export const HiddenFileInput = styled("input", {
  display: "none",
});

export const UploadHelperText = styled("span", {
  fontSize: "12px",
  color: "$gray-60",
});

export const UploadErrorText = styled("span", {
  fontSize: "12px",
  color: "$error-dark",
});

export const UploadProgressTrack = styled("div", {
  height: "4px",
  borderRadius: "999px",
  backgroundColor: "$gray-30",
  overflow: "hidden",
});

export const UploadProgressBar = styled("div", {
  height: "100%",
  backgroundColor: "$primary",
  transition: "width 0.2s ease",
});
